import { Ampliacion } from './../../../models/ampliacion.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var $: any;
@Component({
    selector: "page-ampliacion",
    templateUrl: "./ampliacion.component.html",
    styleUrls: ['./ampliacion.component.css'],
    providers: [FormService]
})

export class AmpliacionComponent {
    @ViewChild('openModal', { static: true }) openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA', { static: true }) openModalNODATA: TemplateRef<any>;
    public rows = [];
    public actualRow;
    public ampliacion: Ampliacion;
    public form;
    public temp_ampl;
    public matcher = new FormService();

    constructor(private dialog: MatDialog) {

        this.form = new FormGroup({
            sup_permiso: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),

            ])),
            superf_terreno: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),

            ])),
            piso1_ex: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),
            ])),
            piso1_amp: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),

            ])),
            piso2_ex: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),

            ])),
            piso2_amp: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),

            ])),
            piso3_ex: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),

            ])),
            piso3_amp: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),

            ])),
            superf_amp: new FormControl('', Validators.compose([
                Validators.pattern('^(0|[1-9][0-9]*)$'),

            ])),
            condominio: new FormControl(''),
            economica: new FormControl('')
        })


        if (!JSON.parse(localStorage.getItem("ampliacion"))) {
            localStorage.setItem("ampliacion", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("ampliacion"));

        }

        this.ampliacion = { sup_permiso: 0, superf_terreno: 0, piso1_ex: 0, piso1_amp: 0, piso2_ex: 0, piso2_amp: 0, piso3_ex: 0, piso3_amp: 0, superf_amp: 0, condominio: "", economica: "" };
        this.temp_ampl = { sup_permiso: 0, superf_terreno: 0, piso1_ex: 0, piso1_amp: 0, piso2_ex: 0, piso2_amp: 0, piso3_ex: 0, piso3_amp: 0, superf_amp: 0, condominio: "", economica: "" };

    }



    add_ampliacion() {

        this.actualRow = localStorage.getItem("ampliacion");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.sup_permiso && !this.form.value.superf_terreno && !this.form.value.piso1_ex && !this.form.value.piso1_amp && !this.form.value.piso2_ex && !this.form.value.piso2_amp
            && !this.form.value.piso3_ex && !this.form.value.piso3_amp && !this.form.value.superf_amp && !this.form.value.condominio && !this.form.value.economica) {
            console.log("no ingresó ningun campo");
            this.dialog.open(this.openModalNODATA);

        } else {
            this.rows = this.rows.concat({
                sup_permiso: this.form.value.sup_permiso,
                superf_terreno: this.form.value.superf_terreno,
                piso1_ex: this.form.value.piso1_ex,
                piso1_amp: this.form.value.piso1_amp,
                piso2_ex: this.form.value.piso2_ex,
                piso2_amp: this.form.value.piso2_amp,
                piso3_ex: this.form.value.piso3_ex,
                piso3_amp: this.form.value.piso3_amp,
                superf_amp: this.form.value.superf_amp,
                condominio: this.form.value.condominio,
                economica: this.form.value.economica

            })
            localStorage.setItem("ampliacion", JSON.stringify(this.rows));
            this.form.reset();
        }
       

        
    }

    get_ampliacion(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_ampl.num_amp = id;
                this.temp_ampl.sup_permiso = this.rows[x].sup_permiso;
                this.temp_ampl.superf_terreno = this.rows[x].superf_terreno;
                this.temp_ampl.piso1_ex = this.rows[x].piso1_ex;
                this.temp_ampl.piso1_amp = this.rows[x].piso1_amp;
                this.temp_ampl.piso2_ex = this.rows[x].piso2_ex;
                this.temp_ampl.piso2_amp = this.rows[x].piso2_amp;
                this.temp_ampl.piso3_ex = this.rows[x].piso3_ex;
                this.temp_ampl.piso3_amp = this.rows[x].piso3_amp;
                this.temp_ampl.superf_amp = this.rows[x].superf_amp;
                this.temp_ampl.condominio = this.rows[x].condominio;
                this.temp_ampl.economica = this.rows[x].economica;

                this.dialog.open(this.openModal);
            }
        }
    }

    cleanData() {
        this.temp_ampl = { sup_permiso: 0, superf_terreno: 0, piso1_ex: 0, piso1_amp: 0, piso2_ex: 0, piso2_amp: 0, piso3_ex: 0, piso3_amp: 0, superf_amp: 0, condominio: "", economica: "" };

    }

    saveAmpliacion() {
        var id = this.temp_ampl.num_amp;
        console.log(this.temp_ampl)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("ampliacion", JSON.stringify(this.rows));

                $("#amp_modal").modal("hide");
                this.actualRow = localStorage.getItem("ampliacion");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    sup_permiso: this.temp_ampl.sup_permiso,
                    superf_terreno: this.temp_ampl.superf_terreno,
                    piso1_ex: this.temp_ampl.piso1_ex,
                    piso1_amp: this.temp_ampl.piso1_amp,
                    piso2_ex: this.temp_ampl.piso2_ex,
                    piso2_amp: this.temp_ampl.piso2_amp,
                    piso3_ex: this.temp_ampl.piso3_ex,
                    piso3_amp: this.temp_ampl.piso3_amp,
                    superf_amp: this.temp_ampl.superf_amp,
                    condominio: this.temp_ampl.condominio,
                    economica: this.temp_ampl.economica
                })
                localStorage.setItem("ampliacion", JSON.stringify(this.rows));
                this.temp_ampl = { sup_permiso: 0, superf_terreno: 0, piso1_ex: 0, piso1_amp: 0, piso2_ex: 0, piso2_amp: 0, piso3_ex: 0, piso3_amp: 0, superf_amp: 0, condominio: "", economica: "" };
                this.dialog.closeAll();

            }
        }
        this.form.reset();
    }
    delete_ampliacion(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("ampliacion", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("ampliacion");
        this.rows = JSON.parse(this.actualRow);
    }

}